import React, { useEffect } from "react";
import queryString from "query-string";
import { STATE_QUERY_PARAM, TOKEN_QUERY_PARAM } from "../config";

export function ConstantContactIntegrationReturnUrl() {
  const params = queryString.parse(window.location.search);
  const code = params?.[TOKEN_QUERY_PARAM] || null;
  const state = params?.[STATE_QUERY_PARAM] || null;

  useEffect(() => {
    if (window.opener != null && code) {
      window.opener.postMessage(
        { childWindow: "response", query: { code, state } },
        window.location.origin,
      );
    }
  }, [code, state]);

  const getMessage = () => {
    if (code) {
      return "Authentication data has been received. You can close this window if it doesn’t close automatically.";
    }

    return "Cannot receive authentication data. Please close this window and retry.";
  };

  return (
    <div id="content">
      <div className="flex justify-center">
        <div className="m-t-20">{getMessage()}</div>
      </div>
    </div>
  );
}
